import { render, staticRenderFns } from "./IconLinkedin.vue?vue&type=template&id=62e5b960&"
import script from "./IconLinkedin.vue?vue&type=script&lang=js&"
export * from "./IconLinkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports